<div class="siteUsersFooter">
  <div class="siteUsersFooter__text">
    {{ footerMessage }}
  </div>
</div>
